import React from 'react';
import classnames from 'classnames';
import { StyledTypography, StyledRouterLink } from './styles';
// TODO создать компонент ссылок
export var LinkRouter = function (_a) {
    var children = _a.children, href = _a.href, _b = _a.isActive, isActive = _b === void 0 ? false : _b, className = _a.className;
    return (React.createElement(StyledRouterLink, { href: href, isActive: isActive },
        React.createElement(StyledTypography, { className: classnames(className, isActive ? 'active-link' : 'inactive-link'), variant: 'body3' }, children)));
};
